import { View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoaderViewModel } from "./serverSideDataLoader-viewModel"

export class ServerSideDataLoaderView extends View<ServerSideDataLoaderViewModel>{
    GetViewUniqueId(): string {
        return "V-05137730-7AF2-4A61-9509-F3B37B9036BD"
    }
    loadHtml(): string {
        let element = require('./serverSideDataLoader.html').default;
        let style = require('./serverSideDataLoader.less');
        return element;
    }
    constructor() {
       super();
    }

    public set functionName(v: string) { this._functionName = v; } public get functionName(): string { return this._functionName;} private _functionName: string;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;

}
